/**
 * フッターコンポーネント
 */
function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-surface-0 shadow-1 p-3 mt-auto">
      <div className="flex flex-column md:flex-row justify-content-between align-items-center">
        <div className="text-sm text-color-secondary mb-2 md:mb-0">
          &copy; {currentYear} epsilonAI. All rights reserved.
        </div>

        <div className="flex gap-3">
          <a href="#" className="text-color-secondary no-underline hover:text-primary">
            <i className="pi pi-book mr-1"></i>
            <span className="hidden md:inline-block">ドキュメント</span>
          </a>
          <a href="#" className="text-color-secondary no-underline hover:text-primary">
            <i className="pi pi-info-circle mr-1"></i>
            <span className="hidden md:inline-block">このアプリについて</span>
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
